export const fileUpload = [
    { label: 'Master Load Plan PO', value: 'MasterLoadPlanPo', },
    { label: 'Master Load Plan SO', value: 'MasterLoadPlanSo', },
    { label: 'Transport Load Plan', value: 'TransportLoadPlan' },
]
export const journeyStatus = [
    { label: 'Shipped', value: 'Shipped', disabled: true },
    { label: 'Picked', value: 'Picked', disabled: false },
    { label: 'Hold', value: 'Hold', disabled: false },
]
export const supplierAddressType = [
    { label: 'Depot', value: 'depots', },
    { label: 'Store', value: 'stores' },
    { label: 'Supplier', value: 'suppliers' },
]

export const displayDataCount = [
    { label: '10', value: '10' },
    { label: '50', value: '50' },
    { label: '100', value: '100' },
    { label: '500', value: '500' },
    { label: '1000', value: '1000' },
]

export const PAGE_CHANGED = 'PAGE_CHANGED';
export const PAGE_SIZE_CHANGED = 'PAGE_SIZE_CHANGED';
export const TOTAL_COUNT_CHANGED = 'TOTAL_COUNT_CHANGED';
export const PAGE_SORT = 'PAGE_SORT';
export enum ActionTypes {
    UPDATE = "Update",
    WRITEOFF = "WriteOff",
    EDIT = "Edit"
}

export enum SERVICES {
    STORES = "stores",
    DEPOTS = "depots",
    SUPPLIERS = "suppliers",
    PURCHASEORDER = "purchaseorders",
    JOURNEY = "transportplans",
    JOURNEYHEADER = "transportplans/Header",
    STOREORDERS = "storeorders",
    STOREORDERHEADER = "storeorders/Header",
    /* STOREORDERHEADER = "Header",*/
    PURCHASEORDERHEADER = "purchaseorders/Header",
    SKUDETAIL = "products",
    CLEARDOWN = "cleardown",
    LOOSELOADINVENTORY = "masterplan/GetLooseLoadAsyc",
    LOOSELOADINVENTORY_BULK_WRITEOFF_GET = "masterplan/LooseLoadBulkWriteOff",
    LOOSELOADINVENTORY_PATCH = "masterplan/LooseLoadDetail",
    /* *//* PALLETDETAIL = "product*//*s/GetPalletDetailsAsyc"*/
    PALLETDETAIL = "masterplan/GetPalletDetailsAsyc",
    //PALLETDETAILSKU_UPDATE = "masterplan/UpdatePalletDetail",
    //PALLETDETAIL = "GetPalletDetailsAsyc",
    // PALLETDETAILWITHSKU = "GetSkusByPalletIdAsyc",
    PALLETDETAILWITHSKU = "masterplan/GetSkusByPalletIdAsyc",
    //PALLETDETAILSKU_UPDATE = "UpdatePalletDetail",
    PALLETDETAILSKU_UPDATE = "masterplan/UpdatePalletDetail",
    LOADJOURNEYMASTERDATA = "transportplans/journey",
    JOURNEY_UPDATE = "transportplans/JourneyDetail",
    JOURNEY_STATUS = "journey/getJourneyStatus/",
    LOADSTUNTTYPEMASTERDATA = "masterplan/GetStuntTypes",
    MANAGECONTACT = "managecontacts",
    MANAGECONTACT_RESEND = "manifests/resend"
}
export enum addresscolumnnames {
    LEGACY_ID = "Address Id",
    CITY = "City",
    LAST_UPDATE_DATE = "updatedDate",
    CREATION_DATE = "createdDate",
    NAME = "Name",
    JS_GROUP_ID = "JS Group Id",
    SUPPLIER_CODE = "supplierCode",
    ADDRESS = "Address",
    ADDRESS2 = "Address2",
    POST_CODE = "Post Code",
}

export enum MESSAGECONSTANTS {
    DESTINATION_ID_REQUIRED = "Destination ID is required",
    DESTINATION_ID_MIN = "Please enter minimum 3 digits",
    DESTINATION_ID_MAX = "Please enter maximum 4 digits",
    DESTINATION_NAME_REQUIRED = "Destination Name is required",
    DESTINATION_NAME_MIN = "Please enter minimum 3 characters",
    DESTINATION_EMAIL_FORMAT = "All emails must be in valid format",
    DESTINATION_EMAIL_ERROR = "is an invalid email",
    DESTINATION_ID_DUPLICATE = "Duplicate Destination ID already added",
    DESTINATION_ADD_CONFIRM = "Confirm you wish to perform changes?",
    DESTINATION_ADD_CONFIRM_DUPLICATE = "Destination ID does not exist, do you wish to continue?",
    DESTINATION_ADD_NOT_EXIST = "Destination ID does not exist",
    SOMETHING_WENT_WRONG = "Something went wrong, please contact to admin",
    UNABLE_TO_DELETE = "Unable to delete, please contact to admin",
    DELETE_SUCCESSFULLY = "Data deleted successfully",
    INSTORE_DATE_CANNOT_LESSER = "In-Store Date must be greater than In-Depot Date",
    UNABLE_TO_UPLAOD_FILE = "Something went wrong, please try again, if issue continue contact with admin",
    UPLAOD_FILE_SUCCESSFULLY = "File uploaded successfully",
    NOT_FOUND_ERROR_MSG="No records found, try with different search criteria",
    UNAUTHORIZED_ERROR_MSG="Your session has been expired, please reload the page",
    UNHANDLED_ERROR_MSG="Something went wrong, please reload the page"
}

export enum RoleKey {
    "a85a8e6b348b4011a1ec1e78e9620782" = "a85a8e6b-348b-4011-a1ec-1e78e9620782",
    "a85a8e6b348b4013a1ec1e78e9620782" = "OriginPick.Admin",
    "a85a8e6b348b4023a1ec1e78e9620782" = "OriginPick.Update",
    "a85a8e6b348b4043a1ec1e78e9620782" = "OriginPick.Reader"
}